import styled from 'styled-components'
import Colors from '../../theme/colors'

export type CardProps = {
  selected?: boolean
}

const Card = styled.div<CardProps>`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 0 0 1px ${Colors.Primary.Grey};
  background: ${Colors.Primary.White};

  ${({ selected = false }) =>
    selected &&
    `
    {
      outline: none;
      box-shadow: 0 0 0 2px ${Colors.Primary.yellow500}, 0 0 0 7px ${Colors.Primary.yellow100};
    }
  `}
`

export default Card
